import React, { Component } from "react";
import Icon from "../templates/icon";
import MessageBroker from "@bonprix/pattern-library/components/message-broker";
import Messages from "./messages";
import Breakpoint from "./breakpoint";

export default class Layer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phase: props.opened ? "open" : "closed",
      top: `${window.pageYOffset}px`,
      startCloserTop: window.pageYOffset,
      needsGlobalGrid: props.needsGlobalGrid,
    };
    window.addEventListener("scroll", () => {
      this.state = {
        scrollTop: window.pageYOffset,
      };
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const willOpen = !this.props.opened && nextProps.opened;
    if (willOpen) {
      this.setState({
        top: `${window.pageYOffset}px`,
        startCloserTop: window.pageYOffset,
      });
    }
  }

  componentDidMount() {
    const subscription = MessageBroker.subscribe(
      Messages.WINDOW.RESIZED,
      this.recalcLayerPosition.bind(this)
    );
    this.setState({ subscription });
  }

  componentWillUnmount() {
    MessageBroker.unsubscribe(this.state.subscription);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.opened) {
      clearTimeout(this.state.timeout);
      if (!this.props.opened) {
        // TODO: onTransitionEnd={this.onTransitionEnd} is buggy on some browser. find fix and delete setTimeout
        this.setState({
          phase: "closing",
          timeout: setTimeout(this.onTransitionEnd.bind(this), 400),
        });
      }
    } else if (this.props.opened && this.state.phase !== "open") {
      this.setState({ phase: "open" });
    }
  }

  recalcLayerPosition() {
    if (this.state.timer) {
      clearTimeout(this.state.timer);
    }
    const timer = setTimeout(() => {
      const activeElementRect = document.activeElement?.getBoundingClientRect();
      const viewportHeight =
        window.innerHeight || document.documentElement.clientHeight;
      if (
        !document.activeElement ||
        activeElementRect.top < 0 ||
        activeElementRect.bottom > viewportHeight
      ) {
        this.setState({
          top: `${window.pageYOffset}px`,
          breakpointChanged: true,
          startCloserTop: window.pageYOffset,
        });
      }
    }, 250);
    this.setState({ timer });
  }

  getCloserStyle(scrollTop, startCloserTop) {
    const contentWrapper = document.body.querySelector(
      "[jsh-layer__content-wrapper]"
    );
    const closerHeight = document.body.querySelector(
      "[jsh-layer__closer]"
    )?.offsetHeight;
    const isInLargeBreakpoints = Breakpoint.keyIsIn(["large", "xlarge", "max"]);
    const layerContainerPadding = isInLargeBreakpoints ? 40 : 0;
    const changeCloserPosition =
      scrollTop > startCloserTop + layerContainerPadding;

    if (!contentWrapper || !changeCloserPosition || this.breakpointChanged) {
      this.breakpointChanged = false;
      return { top: "0px" };
    }

    let layerHeight = 0;
    Array.from(contentWrapper.children).forEach(
      (childNode) => (layerHeight += childNode.offsetHeight)
    );

    // closer should only me moved if it does not cross the lower edge of layer
    const smallBreakpointCompensation = !isInLargeBreakpoints ? 40 : 0; // can't explain this!
    if (
      scrollTop - startCloserTop + smallBreakpointCompensation <=
      layerHeight
    ) {
      return { top: `${scrollTop - startCloserTop - layerContainerPadding}px` };
    }

    // otherwise it should stick to the bottom of layer
    return { top: `${layerHeight - closerHeight}px` };
  }

  onTransitionEnd() {
    this.setState({ phase: "closed", timeout: null });
  }

  onClose(onClose) {
    if (typeof onClose === "function") {
      onClose();
    }
    this.setState({ phase: "closing" });
  }

  renderLayerContent(children, needsGlobalGrid) {
    if (needsGlobalGrid) {
      return children;
    }
    return (
      <div className="layer__content" style={{ top: "0px" }}>
        {children}
      </div>
    );
  }

  render() {
    if (this.state.phase === "closed") {
      return null;
    }
    // TODO: onTransitionEnd={this.onTransitionEnd} is buggy on some browser. find fix and delete setTimeout
    return (
      <div
        {...this.props.testRefs}
        className={
          this.props.className +
          (this.state.phase === "open" ? " is-active" : "")
        }
        style={{ top: this.state.top }}
      >
        <div className="layer__grid">
          <div
            className="layer__background"
            onClick={() => this.onClose(this.props.onClose)}
          />
          <div
            className="layer__content-wrapper"
            jsh-layer__content-wrapper="true"
          >
            {this.renderLayerContent(
              this.props.children,
              this.state.needsGlobalGrid
            )}
          </div>
          <div className="layer__closer-wrapper">
            <div
              className="layer__closer"
              onClick={() => this.onClose(this.props.onClose)}
              style={this.getCloserStyle(
                this.state.scrollTop,
                this.state.startCloserTop
              )}
            >
              <Icon
                name="closer"
                className="layer__closer-icon"
                jsh-layer__closer="true"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
